import React, { useEffect, useState, useRef } from "react";
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { useSelector } from "react-redux";
import { IAM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import { Helmet } from "react-helmet";
import TapIcon from "../../../services/TapIcon";
import download from "../../../services/DownloadFile";
import { DisplaySearchCriteria } from "../../../components/TapUi/index";
import TapSelect from "../../../components/ui/TapSelect";
import EscalationReportDetailModal from "./EscalationReportDetailModal";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Modal } from "bootstrap";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from "react-toastify";
import uuid from "react-uuid";
import DatePicker from "react-datepicker";
import moment from "moment";
import DateService from "../../../services/DateService";

const EscalationReport = (props) => {

    const accessToken                               =   useSelector(state => state.auth.access_token);
    const iam_user_sites                            =   useSelector(state => state.app.user_sites || []);
    const allStatus                            =   useSelector(state => state.app.status_list || []);

    const escalationUrl                             =   IAM_API_BASE_URL_2 + '/user_wise_escalation';
    const formDataUrl                               =   IAM_API_BASE_URL_2 + '/escalation_formdata';
    const escalationShareUrl                        =   IAM_API_BASE_URL_2 + '/escalation_summary_email';
    const escalationDetailRef                       =   useRef(null);
    const criteriaRef                               =   useRef()
    const [loading, setLoading]                     =   useState(false)
    const [listingData, setListingData]             =   useState([])
    const [userData, setUserData]                   =   useState({})
    const [sites, setSites]                         =   useState([])
    const [formSearchedElems, setFormSearchedElems] =   useState([])
    const [reportSubmitted, setReportSubmitted]     =   useState(false)
    const [iam_group_sites, setIam_group_sites]     =   useState([]);
    const [criteriaHeight, setCriteriaHeight]       =   useState(0)
    const [openAccordions, setOpenAccordions]       =   useState({});
    const [ccOptions, setCcOptions]                 =   useState([]);
    const [toOptions, setToOptions]                 =   useState([]);
    const [isParamBasedSearch, setIsParamBasedSearch] = useState(false);
    const modalId                                   =   uuid();
    const modalElementRef                           =   useRef();
    const modalRef                                  =   useRef();

    
    const [formData, setFormData]                   =   useState({
                                                                    loading: false,
                                                                    data: [],
                                                                    allTicketType:[],
                                                                    allStatusList: [],
                                                                });
    const [submittedReportFilterForm, setSubmittedReportFilterForm] = useState({
        'show'                          :   false,
        'search_user'                   :   null,
        'search_site_ids'               :   [],
        'search_ticket_type_ids'        :   [],
        'search_status'                 :   [],
    });
    const [shareEmailForm, setShareEmailForm] = useState({
        to_emails: [],
        cc_emails :[],
        subject:    'Escalation Report as on ' + DateService.dateFormat(new Date()),
        message: '',
        include_attachment: 'N'
    });
    const initShareEmail = {
        to_emails: [],
        cc_emails:[],
        subject:    'Escalation Report as on ' + DateService.dateFormat(new Date()),
        message: '',
        include_attachment: 'N'
    };
    const [saveFormSubmitting, setSaveFormSubmitting] = useState(false);
    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };

    useEffect(() => {
        modalElementRef.current = document.getElementById(modalId);
        modalRef.current = new Modal(modalElementRef.current, {
            keyboard: false,
            backdrop: false
        });
        const handleModalHidden = () => {
            handleClose();
        };

        if (modalElementRef.current) {
            modalElementRef.current.addEventListener('hidden.bs.modal', handleModalHidden);
        }

        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
            if (modalElementRef.current) {
                modalElementRef.current.removeEventListener('hidden.bs.modal', handleModalHidden);
            }
        };
    }, []);
        
    const openModal                 =   () => {
        if (modalRef.current) {
            modalRef.current.show();
        }
    }
    const closeModal                =   () => {
        if (modalRef.current) {
            modalRef.current.hide();
        }
    }
    const reportFilterFormLabel = {
        search_user_id              :   'Tagged User : ',
        'search_site_ids'           :   'Site : ',
        'search_ticket_type_ids'     :   'Ticket Type : ',
        'search_status'             :   'Status : ',
    };
 

    const location = useLocation();
    useEffect(() => {
        loadFormData();
    }, [])

   useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const searchUserId = searchParams.get('search_user_id');

        if (searchUserId) {
            setIsParamBasedSearch(true);
        }
    }, [location.search]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const searchUserId = searchParams.get('search_user_id');

        if (
            searchUserId &&
            formData.data.length > 0 &&
            isParamBasedSearch &&
            !submittedReportFilterForm.search_user
        ) {
            const foundUser = formData.data.find(
                u => u.value === searchUserId
            );

            if (foundUser) {
                setSubmittedReportFilterForm(prev => ({
                    ...prev,
                    search_user: foundUser
                }));
            }
        }
    }, [formData.data, location.search, isParamBasedSearch]);

    useEffect(() => {
        if (
            isParamBasedSearch &&
            submittedReportFilterForm.search_user &&
            !reportSubmitted
        ) {
            reportFilterFormSubmit();
        }
    }, [submittedReportFilterForm.search_user, isParamBasedSearch]);

    useEffect(() => {
        updateCriteriaHeight()
        toggleFilterForm(!submittedReportFilterForm.show);
        // if (formData.data.length <= 0) {
        //     loadFormData();
        // }
    }, [formSearchedElems]);

    useEffect(() => {
        if (listingData.length > 0) {
            const initialAccordionState = {};
            listingData.forEach((level, index) => {
                initialAccordionState[level.id || index] = index === listingData.length - 1;
            });
            setOpenAccordions(initialAccordionState);
        }
    }, [listingData]);

    const submitShareDocument = (event) => {
        event.preventDefault();
        setSaveFormSubmitting(true)
        let frmData = {
            search_ticket_type_ids: submittedReportFilterForm?.search_ticket_type_ids || [],
            search_status: submittedReportFilterForm?.search_status || [],
            'search_user_id': submittedReportFilterForm?.search_user.value,
            'search_site_ids': submittedReportFilterForm?.search_site_ids || [],
            to_user_ids: shareEmailForm?.to_emails?.map(s => s.id),
            cc_user_ids: shareEmailForm?.cc_emails?.map(s => s.id),
            subject: shareEmailForm?.subject,
            message: shareEmailForm?.message,
            include_attachment: shareEmailForm?.include_attachment
        }
        HttpAPICall.withAthorization('POST', escalationShareUrl, accessToken, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            handleClose()
            closeModal()
        }).then(() => setSaveFormSubmitting(false))
    };

    const loadFormData = () => {
        setFormData(pd => ({
            ...pd,
            loading: true,
        }))
        setIam_group_sites(iam_user_sites.map((s) => ({ value: s.id, label: `${s.site_name} (${s.site_code})` })),)
        HttpAPICall.withAthorization('GET', formDataUrl, accessToken, {}, {}, (resp) => {
            let data = resp.data;

            const emailOpts = data?.level_users.map(user => ({
                value: user.email,
                label: ` ${user.email} (${user.first_name} ${user.last_name}) `,
                id: user.enc_id,
               name: `${user.first_name} ${user.last_name}`
            }));
            
            setFormData(pd => ({
                ...pd,
                data: data?.level_users.map(d => ({ value: d.enc_id, label: `${d.first_name} ${d.last_name}` , email :d.email})),
                allTicketType : data.ticket_types?.map((s) => {return { value: s.id, label: s.name }}),
                allStatusList: allStatus?.map((s) => {return { value: s.key, label: s.name }}),
            }));
            setCcOptions(emailOpts);
            setToOptions(emailOpts)
        }).then(() => {
            setFormData(pd => ({ ...pd, loading: false }));
        })
    }
    const handleClose = () => {
        setShareEmailForm(initShareEmail);

    }
    const escalationDetailModalHandle = (site) => {
        if (escalationDetailRef.current && site) {
            escalationDetailRef.current.initModalHandler(site);
        }
    }

    const toggleAccordion = (levelId) => {
        setOpenAccordions(prev => ({
            ...prev,
            [levelId]: !prev[levelId]
        }));
    };
    const closeReport       =   ()  =>  props.history.push({ pathname: `/report` })
    

    const formInputHandler = (event, formName) => {
        const { name, value, type, checked } = event.target;

        if (formName === 'shareEmailForm') {
            setShareEmailForm(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? (checked ? 'Y' : 'N') : value
            }));
        } else if (formName === 'submittedReportFilterForm') {
            setSubmittedReportFilterForm(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const attachmentCheckboxHandler = (e) => {
        setShareEmailForm(prev => ({
            ...prev,
            include_attachment: prev.include_attachment === 'Y' ? 'N' : 'Y'
        }));
    };

    const reportFilterFormSubmit = (event = null) => {
        event && event.preventDefault();

        let searchedElems = [];

        if (submittedReportFilterForm.search_user) {
            const show_val = submittedReportFilterForm.search_user.label;
            searchedElems.push(`${reportFilterFormLabel.search_user_id} <b>${show_val}</b>`);
        }

        if (submittedReportFilterForm.search_site_ids && submittedReportFilterForm.search_site_ids.length > 0) {
            const show_val = iam_group_sites
                .filter((s) => submittedReportFilterForm.search_site_ids.includes(s.value))
                .map(s => s.label)
                .join(', ');
            searchedElems.push(`${reportFilterFormLabel['search_site_ids']} <b>${show_val}</b>`);
        }
        if (submittedReportFilterForm.search_ticket_type_ids && submittedReportFilterForm.search_ticket_type_ids.length > 0) {
            const show_val = formData?.allTicketType
                .filter((s) => submittedReportFilterForm.search_ticket_type_ids.includes(s.value))
                .map(s => s.label)
                .join(', ');
            searchedElems.push(`${reportFilterFormLabel['search_ticket_type_ids']} <b>${show_val}</b>`);
        }
        
        if (submittedReportFilterForm.search_status && submittedReportFilterForm.search_status.length > 0) {
            const show_val = formData?.allStatusList.filter((s) => submittedReportFilterForm.search_status.includes(s.value)).map((s) => s.label).join(", ");
            searchedElems.push(`${reportFilterFormLabel.search_status} <b>${show_val}</b>`);
        }


        setSubmittedReportFilterForm({ ...submittedReportFilterForm });
        setFormSearchedElems(searchedElems);
        setReportSubmitted(true);
        loadListingTblData(1);
    }

    const loadListingTblData = (page = 1) => {
        setLoading(true);

        const params = {
            page: page,
            search_user_id        : submittedReportFilterForm.search_user ? submittedReportFilterForm.search_user.value : "",
            search_site_ids       : submittedReportFilterForm.search_site_ids,
            search_status         : submittedReportFilterForm.search_status,
            search_ticket_type_ids : submittedReportFilterForm.search_ticket_type_ids,
        };

        HttpAPICall.withAthorization('GET', escalationUrl, accessToken, params, {}, (response) => {
            let respData = response.data;
            const filteredData = (respData.data || []).map(level => ({
                ...level,
                sites: (level.sites || [])
                    .filter(site => {
                        const hasData = site.scs > 0 ||
                            site.ticket > 0 ||
                            site.iam_compliance > 0 ||
                            site.compliance_no_doc > 0;
                        return hasData;
                    })
            }));
            setListingData(filteredData || [])
            setUserData({
                user_name: respData.user_name || '',
                report_date: respData.report_date || '',
                sites: respData.sites || [],
                level_name: Array.isArray(respData.levels)
                    ? respData.levels.map(level => level.name).join(', ')
                    : ''
            })
            setSites(respData.sites || [])
        }).then(() => {
            setLoading(false)
        });
    }

    const toggleFilterForm = (show) => {
        setSubmittedReportFilterForm(pd => ({ ...pd, show: show }));
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }
    const handleTicketClick = (level, site) => {
        const ticketFilter = level.rules?.ticket;
        const siteId = site.site_id;
        const ticket_type = submittedReportFilterForm.search_ticket_type_ids;

        let ticketParams = new URLSearchParams({
            site_id: siteId,
            ageing: ticketFilter?.condition ? `${ticketFilter.condition.min}-${ticketFilter.condition.max}` : "",
            exclude_status: ticketFilter?.exclude_status?.join(',') || "",

        });
        if (ticket_type.length > 0) {
            ticketParams.append("ticket_type", ticket_type.join(','));
        }
        window.open(`/ticket?${ticketParams.toString()}`, '_blank');
    }
    const handleComplianceClick = (level, site) => {
        const siteId = site.site_id;
        const complianceFilter = level.rules?.iam_compliance;
        const asset_status = submittedReportFilterForm.search_status

        let queryParams = new URLSearchParams({
            site_id: siteId,
            due_date_start: complianceFilter?.due_date_start ? complianceFilter.due_date_start : "",
            due_date_end: complianceFilter?.due_date_end ? complianceFilter.due_date_end : "",

        });
        if (asset_status.length > 0) {
            queryParams.append("asset_status", asset_status.join(','));
        }

        window.open(`/report/compliance_report?${queryParams.toString()}`, '_blank');
    }
    const handleComplianceNoDocClick = (level, site) => {
        const siteId = site.site_id;
        const complianceFilter = level.rules?.iam_compliance;
        const asset_status = submittedReportFilterForm.search_status

        const queryParams = new URLSearchParams({
            site_id: siteId,
            document_status: "N",

        });
         if (asset_status.length > 0) {
            queryParams.append("asset_status", asset_status.join(','));
        }

        window.open(`/report/compliance_report?${queryParams.toString()}`, '_blank');
    }
    const handleScsClick = (level, site) => {
        const siteId = site.site_id;
        const scsFilter = level.rules?.scs;

        const queryParams = new URLSearchParams({
            site_id: siteId,
        });

        if (scsFilter?.condition) {
            if (scsFilter.condition.max_hr !== undefined && scsFilter.condition.max_hr !== null) {
                queryParams.append('escaltion_scs_max_hr', scsFilter.condition.max_hr);
            }
            if (scsFilter.condition.max_km !== undefined && scsFilter.condition.max_km !== null) {
                queryParams.append('escaltion_scs_max_km', scsFilter.condition.max_km);
            }
            if (scsFilter.condition.min_hr !== undefined && scsFilter.condition.min_hr !== null) {
                queryParams.append('escaltion_scs_min_hr', scsFilter.condition.min_hr);
            }
            if (scsFilter.condition.min_km !== undefined && scsFilter.condition.min_km !== null) {
                queryParams.append('escaltion_scs_min_km', scsFilter.condition.min_km);
            }
        }

        window.open(`/report/service_checksheet_running_status?${queryParams.toString()}`, '_blank');
    }
    const totalHandleTicketClick = (level) => {
        const siteIds = level.sites.map((site) => site.site_id)
        const ticketFilter = level.rules?.ticket;
        const ticket_type = submittedReportFilterForm.search_ticket_type_ids ;
        
        let ticketParams = new URLSearchParams({
            site_id: siteIds,
            ageing: ticketFilter?.condition ? `${ticketFilter.condition.min}-${ticketFilter.condition.max}` : "",
            exclude_status: ticketFilter?.exclude_status?.join(',') || "",
            type: "total_tickets",
        });
        if (ticket_type.length > 0) {
            ticketParams.append("ticket_type", ticket_type.join(','));
        }
        window.open(`/ticket?${ticketParams.toString()}`, '_blank');
    }
    const handleTotalComplianceClick = (level) => {
        const siteIds = level.sites.map((site) => site.site_id)
        const complianceFilter = level.rules?.iam_compliance;
        const asset_status = submittedReportFilterForm.search_status

        const queryParams = new URLSearchParams({
            site_id: siteIds,
            due_date_start: complianceFilter?.due_date_start ? complianceFilter.due_date_start : "",
            due_date_end: complianceFilter?.due_date_end ? complianceFilter.due_date_end : "",
            type: "total_overdueCompliance",
        });
        if (asset_status.length > 0) {
            queryParams.append("asset_status", asset_status.join(','));
        }

        window.open(`/report/compliance_report?${queryParams.toString()}`, '_blank');
    }
    const handleTotalComplianceNoDocClick = (level) => {
        const siteIds = level.sites.map((site) => site.site_id)
        const asset_status = submittedReportFilterForm.search_status

        const queryParams = new URLSearchParams({
            site_id: siteIds,
            document_status: "N",
            type: "total_ComplianceNoDoc",
        });
        if (asset_status.length > 0) {
            queryParams.append("asset_status", asset_status.join(','));
        }

        window.open(`/report/compliance_report?${queryParams.toString()}`, '_blank');
    }
    const handleTotalScsClick = (level) => {
        const siteIds = level.sites.map((site) => site.site_id)
        const scsFilter = level.rules?.scs;

        const queryParams = new URLSearchParams({ site_id: siteIds, type: "total_scs" });

        if (scsFilter?.condition) {
            if (scsFilter.condition.max_hr !== undefined && scsFilter.condition.max_hr !== null) {
                queryParams.append('escaltion_scs_max_hr', scsFilter.condition.max_hr);
            }
            if (scsFilter.condition.max_km !== undefined && scsFilter.condition.max_km !== null) {
                queryParams.append('escaltion_scs_max_km', scsFilter.condition.max_km);
            }
            if (scsFilter.condition.min_hr !== undefined && scsFilter.condition.min_hr !== null) {
                queryParams.append('escaltion_scs_min_hr', scsFilter.condition.min_hr);
            }
            if (scsFilter.condition.min_km !== undefined && scsFilter.condition.min_km !== null) {
                queryParams.append('escaltion_scs_min_km', scsFilter.condition.min_km);
            }
        }

        window.open(`/report/service_checksheet_running_status?${queryParams.toString()}`, '_blank');

    }
    const reportDownloadHandler = (type) => {
        const downloadParams = {
            type: type,
            download: 'download',
            search_user_id        : submittedReportFilterForm.search_user ? submittedReportFilterForm.search_user.value : "",
            search_site_ids       : submittedReportFilterForm.search_site_ids,
            search_status         : submittedReportFilterForm.search_status,
            search_ticket_type_ids : submittedReportFilterForm.search_ticket_type_ids,
            
        };

        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/escalation_data_download', accessToken, downloadParams, {}, (response) => download.file(response.data.file_path, response.data.msg));
    }
    const shareTicketModalInit = () => {

        if (submittedReportFilterForm.search_user?.email) {
            const matchedEmail = toOptions.find(
                opt => opt.value === submittedReportFilterForm.search_user.email
            );

            if (matchedEmail) {
                setShareEmailForm(prev => ({
                    ...prev,
                    to_emails: [matchedEmail]
                }));
            }
        }

        openModal();
    };

    const shareTicketModalJsx = () => {
        const filteredCcOptions = ccOptions.filter(
            ccOpt =>
                !shareEmailForm.to_emails?.some(
                    to => to.value === ccOpt.value
                )
        );

        
        return (
            <div className="modal fade" id={modalId}
                ref={modalElementRef} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssetModalLabel">Share Escalation Report</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}></button>
                        </div>

                        <form onSubmit={submitShareDocument} className="mx-2" id={modalId + "filter"}>
                            <div className="modal-body">
                                <div className="row align-items-center mb-3">
                                    <div className="col-sm-3">
                                        <label className="form-label require">Tagged User</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <input type="text" disabled className="form-control" value={userData.user_name} />
                                    </div>
                                </div>
                                {submittedReportFilterForm.search_site_ids && submittedReportFilterForm.search_site_ids.length > 0 && userData.sites && userData.sites.length > 0 &&
                                    <div className="row align-items-center my-3">
                                        <div className="col-sm-3">
                                            <label className="form-label">Sites</label>
                                        </div>
                                        <div className="col-sm-9">
                                        <input type="text" disabled className="form-control" value={
                                                    userData.sites
                                                        .slice(0, 4)
                                                        .map(site => site.site_name)
                                                        .join(', ') +
                                                    (userData.sites.length > 4
                                                        ? `, + ${userData.sites.length - 4} more`
                                                        : "")
                                                } />
                                        </div>
                                    </div>}

                                {submittedReportFilterForm.search_ticket_type_ids && submittedReportFilterForm.search_ticket_type_ids.length > 0 && (
                                    <div className="row align-items-center my-3">
                                        <div className="col-sm-3">
                                            <label className="form-label">Ticket Type</label>
                                        </div>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                disabled
                                                className="form-control"
                                                value={
                                                    formData.allTicketType
                                                        .slice(0, 4)
                                                        .map(t => t.label)
                                                        .join(', ') +
                                                    (formData.allTicketType.length > 4
                                                        ? `, + ${formData.allTicketType.length - 4} more`
                                                        : "")
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                                {submittedReportFilterForm.search_status?.length > 0 && (
                                    <div className="row align-items-center my-3">
                                        <div className="col-sm-3">
                                            <label className="form-label">Asset Status</label>
                                        </div>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                disabled
                                                className="form-control"
                                                value={
                                                    formData.allStatusList
                                                        .filter(s => submittedReportFilterForm.search_status.includes(s.value))
                                                        .map(s => s.label)
                                                        .join(', ') || "-"
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="row align-items-center">
                                    <div className="col-md-3">
                                        <label className="form-label require">To (Email)</label>
                                    </div>
                                    <div className="col-md-9">
                                        <TapSelect
                                            options={toOptions}
                                            changeEvent={(selectedOption) => {
                                                setShareEmailForm(prev => {
                                                    const toEmails = selectedOption ? [selectedOption] : [];
                                                    return {
                                                        ...prev,
                                                        to_emails: toEmails,
                                                        cc_emails: prev.cc_emails?.filter(
                                                            cc => !toEmails.some(to => to.value === cc.value)
                                                        )
                                                    };
                                                });
                                            }}
                                            isDisabled={true}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={toOptions.filter(option =>
                                                shareEmailForm.to_emails?.some(
                                                    email => email.value === option.value
                                                )
                                            )}
                                            placeholder="Select User"
                                        />

                                    </div>
                                </div>
                                <div className="row align-items-center mt-3">
                                    <div className="col-md-3">
                                        <label className="form-label ">CC (Email)</label>
                                    </div>
                                    <div className="col-md-9">
                                        <TapSelect
                                            options={filteredCcOptions}
                                            changeEvent={(selectedOption) => {
                                                setShareEmailForm(prev => ({
                                                    ...prev,
                                                    cc_emails: selectedOption || []
                                                }));
                                            }}
                                            value={filteredCcOptions.filter(option =>
                                                shareEmailForm.cc_emails?.some(email => email.value === option.value)
                                            )}
                                            isSearchable={true}
                                            isMulti={true}
                                            isClearable={true}
                                            placeholder="Select or enter CC email addresses"
                                        />
                                    </div>
                                </div>
                                <div className="row align-items-center mt-3">
                                    <div className="col-md-3">
                                        <label className="form-label require">Subject</label>
                                    </div>

                                    <div className="col-md-9">
                                        <input
                                            name="subject"
                                            value={shareEmailForm.subject}
                                            className="form-control text-capitalize"
                                            autoComplete="off"
                                            required
                                            onChange={(e) => formInputHandler(e, 'shareEmailForm')}
                                            placeholder="Enter Subject"
                                        />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-3">
                                        <label className="form-label require">Message</label>
                                    </div>
                                    <div className="col-md-12">
                                        <CKEditor
                                            required
                                            data={shareEmailForm.message}
                                            editor={ClassicEditor}
                                            onChange={(event, editor) => {
                                                setShareEmailForm({
                                                    ...shareEmailForm,
                                                    message: editor.getData()
                                                })
                                            }}
                                            config={{
                                                placeholder: 'Please Enter Text',
                                                height: '300px',
                                                toolbar: ['heading', '|', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList']
                                            }}
                                        />
                                    </div>
                                </div></div>
                            <div className="modal-footer d-flex justify-content-between">
                                <div className="mt-0">
                                    <input
                                        name="include_attachment"
                                        type="checkbox"
                                        checked={shareEmailForm.include_attachment === 'Y'}
                                        onChange={attachmentCheckboxHandler}
                                        className="form-check-input"
                                    />
                                    <label className="form-check-label mx-2">
                                        Attach Escalation Report with Email
                                    </label>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-secondary me-2"
                                        data-bs-dismiss="modal"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        form={modalId + "filter"}
                                        className="btn btn-primary"
                                        disabled={saveFormSubmitting}
                                    >
                                        Submit {saveFormSubmitting && (
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

const pageTitleBarJsx = () => {
        return (
            <div className="page_title row m0">
                <div className="col-sm-12 px-2">
                    <div className="d-flex align-items-center justify-content-between ">
                        <h3><TapIcon.FontAwesomeIcon icon={TapIcon.faChartLine} /> Escalation Report</h3>
                        <div className="d-flex align-items-center ">
                            <button type="button" className="btn btn-secondary" onClick={() => toggleFilterForm(!submittedReportFilterForm.show)} >
                                Change Filter
                            </button>
                            {reportSubmitted && (
                                <>
                                    <button type="button" id='shareTicket' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                        <TapIcon.FontAwesomeIcon icon={TapIcon.faShareAlt} className="img-fluid" alt="item-action" />
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="shareTicket">
                                        <li><Link className="dropdown-item" role="button" onClick={shareTicketModalInit}>Share by Email</Link></li>
                                    </ul>
                                    <div className="dropdown ">
                                        <button
                                            type="button"
                                            id="actionMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className="btn btn-secondary"
                                        >
                                            <TapIcon.imageIcon
                                                icon={TapIcon.ActionIcon}
                                                className="img-fluid"
                                                alt="action"
                                            />
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li>
                                                <button
                                                    onClick={() => { reportDownloadHandler("scs_running_status") }}
                                                    className="dropdown-item"
                                                    role="button"
                                                >
                                                    SCS Download
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => { reportDownloadHandler("ticket") }}
                                                    className="dropdown-item"
                                                    role="button"
                                                >
                                                    Ticket Download
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => { reportDownloadHandler("iam_compliance") }}
                                                    className="dropdown-item"
                                                    role="button"
                                                >
                                                    Overdue Compliance Download
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </>
                            )}
                            <button type="button" className="btn btn-secondary" onClick={closeReport}>
                                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const reportFilterFormJsx = () => {
        return (
            <form onSubmit={reportFilterFormSubmit} className='py-3'>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end require">Tagged User</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.data}
                            changeEvent={selectedOption => {
                                setSubmittedReportFilterForm(d => ({
                                    ...d,
                                    search_user: selectedOption ? selectedOption : null
                                }));
                            }}
                            required={true}
                            isSearchable={true}
                            isClearable={true}
                            value={submittedReportFilterForm.search_user}
                            placeholder="Select User"
                        />
                    </div>
                </div>
                <div className='row mb-3'>
                    <label className="col-sm-3 col-form-label col-form-label-sm text-end ">Ticket Type</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allTicketType}
                             changeEvent={o => setSubmittedReportFilterForm(d => ({ ...d, search_ticket_type_ids: o.map(e => e.value) }))}
                            isSearchable={true}
                            isClearable={true}  
                            isMulti={true}
                            value={formData.allTicketType.filter(s => submittedReportFilterForm.search_ticket_type_ids.includes(s.value))}
                            placeholder="Select Ticket Type"
                        />
                    </div>
                </div>
                <div className='row mb-3'>
                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Site</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={iam_group_sites}
                            changeEvent={o => setSubmittedReportFilterForm(d => ({ ...d, search_site_ids: o.map(e => e.value) }))}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={iam_group_sites.filter(s => submittedReportFilterForm.search_site_ids.includes(s.value))}
                            placeholder="Select Site"
                        />
                    </div>
                </div>
                <div className='row mb-3'>
                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Status</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allStatusList}
                            changeEvent={o => setSubmittedReportFilterForm(d => ({ ...d, search_status: o.map(e => e.value) }))}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={formData.allStatusList.filter((s) =>
                                submittedReportFilterForm.search_status.includes(s.value)
                            )}
                            placeholder="Select Asset Status"
                        />
                    </div>
                </div>
                 
                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={loading} className="btn btn-primary px-4">Show Report</button>
                    </div>
                </div>
            </form>
        );
    }

    const renderEscalationLevel = (level, index) => {
        const totalSCS = level.sites.reduce((sum, site) => sum + (site.scs || 0), 0);
        const totalTickets = level.sites.reduce((sum, site) => sum + (site.ticket || 0), 0);
        const overdueCompliance = level.sites.reduce((sum, site) => sum + (site.iam_compliance || 0), 0)
        const compliancewithoutDoc = level.sites.reduce((sum, site) => sum + (site.compliance_no_doc || 0), 0)
        const hasMultipleSites = level.sites.length > 1;
        const isOpen = openAccordions[level.id || index];
        const levelId = level.id || index;
        const showAccordion = hasMultipleSites;
        const showContent = !showAccordion || isOpen;

        return (
            <div key={levelId} className="mb-3 mx-3">
                <span className="fw-bold">{level.name}</span>
                <div className="col-12 ">
                    <div className="table-responsive">
                        <table className="table table-hover table-bordered bg-white my-2">
                            <thead className="table-secondary">
                                <tr className="text-center">
                                    <th style={{ width: "12%" }} >
                                        <span className="d-flex flex-column">
                                            {showAccordion && (
                                                <span
                                                    onClick={() => toggleAccordion(levelId)}
                                                    style={{ cursor: "pointer", color: "#595d61ff", textAlign: "start" }}
                                                >
                                                    {isOpen ? '▲' : '▼'}
                                                </span>
                                            )}
                                            <span>Project</span>
                                        </span>
                                    </th>
                                    <th style={{ width: "8%" }}>#</th>
                                    <th style={{ width: "20%" }}>{level?.rules?.scs?.name || ""}</th>
                                    <th style={{ width: "20%" }}>{level?.rules?.ticket?.name || ""}</th>
                                    <th style={{ width: "20%" }}>{level?.rules?.iam_compliance?.name || ""}</th>
                                    <th style={{ width: "20%" }}>{level?.rules?.compliance_no_doc?.name || ""}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hasMultipleSites &&
                                    <tr className="text-center">
                                        <td><strong>Total</strong></td>
                                        <td>-</td>
                                        <td>
                                            {totalSCS > 0 ? (
                                                <button
                                                    type="button"
                                                    onClick={() => handleTotalScsClick(level)}
                                                    className="text-primary text-decoration-none border-0 bg-transparent"
                                                >
                                                    {totalSCS}
                                                </button>
                                            ) : "-"}
                                        </td>
                                        <td>
                                            {totalTickets > 0 ? (
                                                <button
                                                    type="button"
                                                    onClick={() => totalHandleTicketClick(level)}
                                                    className="text-primary text-decoration-none border-0 bg-transparent p-0"
                                                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                >
                                                    {totalTickets}
                                                </button>
                                            ) : "-"}
                                        </td>
                                        <td>
                                            {overdueCompliance > 0 ? (
                                                <button
                                                    type="button"
                                                    onClick={() => handleTotalComplianceClick(level)}
                                                    className="text-primary text-decoration-none border-0 bg-transparent"
                                                >
                                                    {overdueCompliance}
                                                </button>
                                            ) : "-"}
                                        </td>
                                        <td>
                                            {compliancewithoutDoc > 0 ? (
                                                <button
                                                    type="button"
                                                    onClick={() => handleTotalComplianceNoDocClick(level)}
                                                    className="text-primary text-decoration-none border-0 bg-transparent"
                                                >
                                                    {compliancewithoutDoc}
                                                </button>
                                            ) : "-"}
                                        </td>
                                    </tr>
                                }

                                {showContent && (
                                    level.sites && level.sites.length > 0 ? (
                                        level.sites.map((site, siteIndex) => {
                                            return (
                                                <tr key={site.site_id || siteIndex} className="text-center">
                                                    <td>{site.site_name || "-"} -
                                                        ({sites.find(s => s.id === site.site_id)?.site_code || "-"})
                                                    </td>
                                                    <td style={{ cursor: "pointer" }} onClick={() => { escalationDetailModalHandle(site) }}><TapIcon.FontAwesomeIcon icon={TapIcon.faUsers} /></td>
                                                    <td>
                                                        {level?.rules?.scs && site.scs > 0 ? (
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    handleScsClick(level, site);
                                                                }}
                                                                className="text-primary text-decoration-none border-0 bg-transparent"
                                                            >
                                                                {site.scs}
                                                            </button>
                                                        ) : "-"}
                                                    </td>
                                                    <td>
                                                        {level?.rules?.ticket && site.ticket > 0 ? (
                                                            <button
                                                                type="button"
                                                                onClick={() => handleTicketClick(level, site)}
                                                                className="text-primary text-decoration-none border-0 bg-transparent p-0"
                                                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                            >
                                                                {site.ticket}
                                                            </button>
                                                        ) : "-"}
                                                    </td>
                                                    <td>
                                                        {level?.rules?.iam_compliance && site.iam_compliance > 0 ? (
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    handleComplianceClick(level, site);
                                                                }}
                                                                className="text-primary text-decoration-none border-0 bg-transparent"
                                                            >
                                                                {site.iam_compliance}
                                                            </button>
                                                        ) : "-"}
                                                    </td>
                                                    <td>{level?.rules?.compliance_no_doc && site.compliance_no_doc > 0 ? (
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                handleComplianceNoDocClick(level, site);
                                                            }}
                                                            className="text-primary text-decoration-none border-0 bg-transparent"
                                                        >
                                                            {site.compliance_no_doc}
                                                        </button>
                                                    ) : "-"}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr className="text-center">
                                            <td colSpan="6">No Record</td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    const reportContentJsx = () => {
        return (
            <div className="bg-white pb-4">
                {loading ? <Loader /> : (
                    <>
                        <table className="table table-hover table-borderless mx-2">
                            <tbody>
                                <tr>
                                    <td className="details-label" style={{ "width": "30%" }}>Date </td>
                                    <td className="details-name" style={{ "width": "66%" }}>{userData.report_date || "-"}</td>
                                </tr>
                                <tr>
                                    <td className="details-label">Name of the stakeholder</td>
                                    <td className="details-name">{userData.user_name || "-"}</td>
                                </tr>
                                <tr>
                                    <td className="details-label">Role / Level</td>
                                    <td className="details-name">{userData.level_name || "-"}</td>
                                </tr>
                                <tr>
                                    <td className="details-label">Sites</td>
                                    <td className="details-name">
                                        {userData.sites && userData.sites.length > 0 ? (
                                            <>
                                                {userData.sites.slice(0, 3).map(site => site.site_name).join(', ')}
                                                {userData.sites.length > 3 && `, + ${userData.sites.length - 3} more`}
                                            </>
                                        ) : '-'}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {listingData.map((level, index) => renderEscalationLevel(level, index))}
                        {listingData.length === 0 && !loading && (
                            <div className="text-center py-4">
                                <p>No escalation data available for the selected criteria</p>
                            </div>
                        )}
                    </>
                )}
            </div>
        );
    }

    return (
        <ApplicationLayout>
            <Helmet><title>Escalation Report</title></Helmet>
            {pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-sm-12 pb-3">
                        <div className={["bg-white", submittedReportFilterForm.show ? 'tbShow' : 'tbHide'].join(" ")}>
                            {formData.loading ? <Loader /> : reportFilterFormJsx()}
                        </div>
                        {reportSubmitted && (
                            <>
                                {formSearchedElems.length > 0 && (
                                    <div ref={criteriaRef}
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                        }}>
                                        <DisplaySearchCriteria searchedElems={formSearchedElems} />
                                    </div>
                                )}
                                {reportContentJsx()}
                            </>
                        )}
                    </div>
                </div>
            </div>
            <EscalationReportDetailModal ref={escalationDetailRef} />
            {shareTicketModalJsx()}
        </ApplicationLayout>
    );
};

export default EscalationReport;